import {moment} from 'helpers';
import {format} from '../decode/convert';

export function activities(activity) {
  return {
    allDay: activity.allDay ? 1 : 0,
    categoryId: activity.habitTypeId ? parseInt(activity.habitTypeId) : null,
    dailyRoutineId: activity.dailyRoutineId,
    date: activity.ts ? moment.unix(activity.ts).format(format) : '',
    dayParts: activity.dayParts,
    duration: activity.duration,
    endDate: activity.endDate ? moment.unix(activity.endDate).format(format) : '',
    goalId: activity.goal_id || 0,
    googleCalendarId: activity.googleCalendarId || '',
    googleEventId: activity.googleEventId || '',
    importedEvent: activity.importedEvent ? 1 : 0,
    isRecurring: 1*Boolean(activity.repeatType),
    localMark: activity.localMark,
    months: activity.months,
    name: activity.name,
    notes: activity.note,
    numericalTarget: activity.numericalTarget,
    numericalTargetUnit: activity.numericalTargetUnit,
    orderIndex: activity.orderIndex,
    priority: activity.priority,
    reminder: activity.reminder,
    reminderInterval: activity.reminderInterval,
    repeatCount: activity.repeatType ? activity.repeatCount : -1,
    repeatCountPerDay: activity.repeatCountPerDay,
    repeatDays: activity.repeatDays,
    repeatType: activity.repeatType,
    repetitionInterval: activity.repetitionInterval,
    scheduleDate: activity.scheduleDate ? moment.unix(activity.scheduleDate).format(format) : '',
    serverId: activity.id,
    status: activity.repeatType ? 'Not Started' : activity.status,
    tagIds: activity.tagIds,
    targetValue: activity.result,
    time: activity.time || '',
    timeInterval: activity.timeInterval,
    times: activity.times || '',
    type: activity.dailyRoutineType,
    unit: activity.unit,
    unitId: activity.unitId,
  }
}

